import Row from '$tablet-app/src/app/components/Row';
import Text from '$tablet-app/src/app/components/Text';
import { CalendarItem } from '$tablet-app/src/app/models';
import { margin, spacing } from '$tablet-app/src/app/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { format } from 'date-fns';
import React, { FC } from 'react';
import { View } from 'react-native';

interface CalendarItemTimeDisplayProps {
  item: CalendarItem;
}

const CalendarItemTimeDisplayWhite: FC<CalendarItemTimeDisplayProps> = (props) => {
  const { item } = props;
  const hasEndDate = !!(
    item.type !== 'Alert' &&
    item.type !== 'Alarm' &&
    item.end
  );

  return (
    <Row alignItems="center" flexWrap="wrap" maxWidth={'100%'} gap={spacing[3]}>
      <FontAwesomeIcon
        style={margin(0, 15, 0, 0)}
        size={18}
        icon="clock"
        color="white"
      />

      <View style={{ maxWidth: '86%' }}>
        <Text style={{ color: 'white' }}>
          {format(item.start, 'EEEE, d MMM')}
        </Text>

        {hasEndDate ? (
          <Text preset="h3" style={{ color: 'white' }}>
            {displayTime(item.start)} - {displayTime((item as any).end)}
          </Text>
        ) : (
          <Text preset="h3" style={{ color: 'white' }}>
            {displayTime(item.start)}
          </Text>
        )}
      </View>
    </Row>
  );
};

const displayTime = (time: Date) => format(time, 'p');

export default CalendarItemTimeDisplayWhite;
